// extracted by mini-css-extract-plugin
export var educationValue = "index-module--educationValue--WgCPn";
export var inner = "index-module--inner--sYOwg";
export var logo = "index-module--logo--OYnwN";